// extracted by mini-css-extract-plugin
export default {"sizerContainer":"Sizer_sizerContainer__eM1ox","sizerWrapper":"Sizer_sizerWrapper__4jYmy"};